'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const DEFAULT_BACKGROUND_COLORS = ["darkgrey", "lightgrey"];
const DEFAULT_TEXT_COLORS = ["black"];
const DEFAULT_SPIN_DURATION = 1;
const DEFAULT_PRIZE_ANGLE = 90;

exports.DEFAULT_BACKGROUND_COLORS = DEFAULT_BACKGROUND_COLORS;
exports.DEFAULT_PRIZE_ANGLE = DEFAULT_PRIZE_ANGLE;
exports.DEFAULT_SPIN_DURATION = DEFAULT_SPIN_DURATION;
exports.DEFAULT_TEXT_COLORS = DEFAULT_TEXT_COLORS;
